import { render, staticRenderFns } from "./OrderCopyModal.vue?vue&type=template&id=231fd99c&"
import script from "./OrderCopyModal.vue?vue&type=script&lang=js&"
export * from "./OrderCopyModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderCopyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports